import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createAssetType, getAssetType, updateAssetType } from "../services/assetTypeService";
import "../styles/AssetForm.css";

const AssetTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = Boolean(id);
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [loading, setLoading] = useState(isEditing);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) return;

    const loadAssetType = async () => {
      try {
        const assetType = await getAssetType(id);
        setFormData({
          name: assetType.name || "",
          description: assetType.description || "",
        });
      } catch (requestError) {
        setError(requestError.response?.data?.message || "Unable to load asset type.");
      } finally {
        setLoading(false);
      }
    };

    loadAssetType();
  }, [id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError("");

    try {
      if (isEditing) {
        await updateAssetType(id, formData);
      } else {
        await createAssetType(formData);
      }
      navigate("/asset-types");
    } catch (requestError) {
      const messages = requestError.response?.data?.messages;
      setError(messages?.join(", ") || requestError.response?.data?.message || "Unable to save asset type.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading">Loading asset type...</div>;

  return (
    <div className="asset-form-container">
      <h1>{isEditing ? "Edit Asset Type" : "Create Asset Type"}</h1>
      {error && <div className="error">{error}</div>}

      <form className="asset-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">
            Name <span className="required">*</span>
          </label>
          <input id="name" name="name" type="text" value={formData.name} onChange={handleChange} maxLength={100} required />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea id="description" name="description" value={formData.description} onChange={handleChange} />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving..." : isEditing ? "Update Asset Type" : "Create Asset Type"}
          </button>
          <Link to="/asset-types" className="btn btn-secondary">
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
};

export default AssetTypeForm;
